import React from "react";
import { moneyShort, AGE_BUCKETS } from "@/lib/posting";

const DevNote = () => (
  <span className="pp-devnote" data-testid="pp-devnote">⚙ Dev note · API under development</span>
);

// Three posting money cards (v19 look). ALWAYS all-time; each shows an aging
// breakdown on the right. Aggregates computed client-side (no summary API).
export function MoneyCards({ stats, loading, onAcceptAllReady }) {
  return (
    <div className="pp-moneyhd" data-testid="pp-money-cards">
      <Card testid="pp-card-unapplied" cls="pp-hero" loading={loading}
        label="Total UnApplied Amount" value={moneyShort(stats.totalUnapplied.amt)}
        sub={`${stats.totalUnapplied.n} check${stats.totalUnapplied.n === 1 ? "" : "s"} — drive to zero · all time`}
        buckets={stats.totalUnapplied.buckets} />
      <Card testid="pp-card-ready" cls="pp-ready" loading={loading}
        label="Ready to accept" value={moneyShort(stats.ready.amt)}
        sub={`${stats.ready.n} auto-matched check${stats.ready.n === 1 ? "" : "s"} · 1-click`}
        buckets={stats.ready.buckets}
        action={
          <button onClick={onAcceptAllReady} data-testid="pp-accept-all-ready" disabled={!stats.ready.n} className="pp-acceptall">
            Accept all ready →
          </button>
        } />
      <Card testid="pp-card-gaps" cls="" loading={loading} valRed
        label="Gaps · couldn't post" value={moneyShort(stats.gaps.amt)}
        sub={`${stats.gaps.n} check${stats.gaps.n === 1 ? "" : "s"} · need a rule or a look`}
        buckets={stats.gaps.buckets} />
    </div>
  );
}

function Breakdown({ buckets, testid }) {
  if (!buckets) return null;
  return (
    <div className="pp-mbreak" data-testid={`${testid}-breakdown`}>
      <div className="pp-mbreak-h">Aging</div>
      {AGE_BUCKETS.map((b) => {
        const cell = buckets[b.id] || { amt: 0, n: 0 };
        return (
          <div key={b.id} className={`pp-mbreak-row ${cell.amt ? "" : "pp-zero"}`} data-testid={`${testid}-bucket-${b.id}`}>
            <span className="pp-mbreak-k">{b.label}</span>
            <span className="pp-mbreak-v">{moneyShort(cell.amt)}</span>
          </div>
        );
      })}
    </div>
  );
}

function Card({ label, value, sub, cls, action, loading, testid, valRed, buckets }) {
  return (
    <div className={`pp-mcard pp-mcard2 ${cls}`} data-testid={testid}>
      <div className="pp-mcard-main">
        <DevNote />
        <div className="pp-l">{label}</div>
        {loading ? (
          <>
            <div className="pp-mshim pp-shimmer" data-testid={`${testid}-shimmer`} />
            <div className="pp-mshim2 pp-shimmer" />
          </>
        ) : (
          <>
            <div className="pp-n" style={valRed ? { color: "var(--red)" } : undefined}>{value}</div>
            <div className="pp-s">{sub}</div>
          </>
        )}
        {!loading && action ? action : null}
      </div>
      {!loading ? <Breakdown buckets={buckets} testid={testid} /> : null}
    </div>
  );
}
